/**
  * Returns a list with stopwords for the Italian passive voice assessment.
  * @returns {Array} The list with stopwords.
  */
export default [
	"a condizione che",
	"a meno che non",
	"a patto che",
	"a seconda che",
	"acché",
	"affinché",
	"al fine di",
	"allorché",
	"allorquando",
	"anche se",
	"anziché",
	"avvegnaché",
	"basta que",
	"benché",
	"beninteso que",
	"chi",
	"cui",
	"dal momento che",
	"dopo che",
	"dove",
	"finché non",
	"fintantoché",
	"i quali",
	"il quale",
	"in caso",
	"in modo che",
	"la quale",
	"le quali",
	"malgrado",
	"mentre",
	"nel caso in cui",
	"nel eventualità che",
	"nonostante che",
	"ogni volta che",
	"per il fatto che",
	"perché",
	"piuttosto che",
	"piuttosto di",
	"poiche",
	"prima che",
	"purché",
	"qualora",
	"quando",
	"quantunque",
	"quello che",
	"sebbene",
	"senza che",
	"siccome",
	"tranne che",
	"una volta che",
];

